










import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import QueryCondition from '@/model/QueryCondition'
import QueryItem from '@/components/QueryItem.vue'
import Qs from 'qs'

@Component({
  components: {
    QueryItem
  }
})
export default class QueryForm extends Vue {

  @Prop() private items!: Array<QueryCondition>

  private conditions: Map<string, string> = new Map()

  private valueChanged (name: string, value: string) {
    if (value == null || value === '') {
      this.conditions.delete(name)
    } else {
      this.conditions.set(name, value)
    }
  }

  private query () {

    const search = location.search.replace(/^\?/, '')
    const params = Qs.parse(search)

    for (const item of this.items) {
      params[item.name] = undefined
    }

    for (const [key, val] of this.conditions) {
      if (val != null && val.length > 0) {
        params[key] = encodeURIComponent(val)
      }
    }
    const url = location.protocol + '//' + location.host + location.pathname + '?' + Qs.stringify(params, {
      strictNullHandling: true,
      skipNulls: true
    })
    if (url !== location.href) {
      window.history.pushState(null, document.title, url)
    }
    this.emitQuery(this.conditions)
  }

  @Emit('query')
  private emitQuery (condition: Map<string, string>) {
    //
  }

}
